import {api} from './requestGraphql'

const blocking = async (payload) => {

  let preparedFilters = ''

  if (payload.filters) {
    for (const filter in payload.filters) {
      preparedFilters += (!!payload.filters[filter]) ?
        `${filter}: "${payload.filters[filter]}"` : ''
    }
  }
  try {
    const res = await api.post(
      '', {
        query: `
            {
              blocking(
                 pagination: {
                    page: ${payload.pagination.page},
                    limit: ${payload.pagination.limit}
                },
                filters: {
                  ${preparedFilters}
                }
                sorting: {
                    orderBy: "${ !payload.sorting ? '' : payload.sorting.orderBy }",
                    orderDirectionAsc: ${ !payload.sorting ? true : payload.sorting.orderDirectionAsc}
                }
              ){
                 count,
                 data {
                    id
                    affiliateId 
                    affiliateName
                    campaignId
                    campaignName
                    fieldName
                    fieldValue
                    heldPayments
                    dateAdded
                    context
                    countriesCode
                    user
                    isBlockTraffic
                    isBlockPayments
                    isAffiliateBlacklisted
                }
              }
            }
        `,
      }
    )
    return res.data.data.blocking
  } catch (e) {
    console.log(e)
  }
}

const addBlocking = async (payload) => {

  try {
    const res = await api.post(
      '', {
        query: `
               mutation{
                  addBlocking(
										affiliateId:${payload.affiliateId},
                    campaignId: ${payload.campaignId},
                    fieldValue:"${payload.fieldValue}",
                    context:"${payload.context}",
                    user:"${payload.user}",
                    isBlockTraffic:${payload.isBlockTraffic},
                    isBlockPayments:${payload.isBlockPayments},
                    isAffiliateBlacklisted:${payload.isAffiliateBlacklisted},
                    blockCountries:"${payload.blockCountries}",
                  ){
                    id
                    error
                  }
            },
        `,
      }
    )
    return res.data.data.addBlocking
  } catch (e) {
    console.log(e)
  }
}

const delBlocking = async (payload) => {

  try {
    const res = await api.post(
      '', {
        query: `
               mutation{
                  delBlocking(
										id:${payload.id},
                  ){
                    id
                    error
                  }
            },
        `,
      }
    )
    return res.data.data.delBlocking
  } catch (e) {
    console.log(e)
  }
}

const getActiveAffiliates = async (data) => {

  try {
    const res = await api.post(
      '', {
        query: `
          {
            getActiveAffiliates(searchFilter: "${data ? data.searchFilter : ''}"){
                id
                affiliateName    
                status
            } 
          }
        `,
      }
    )

    let response = res.data.data.getActiveAffiliates
    return response
  } catch (e) {
    console.log(e)
  }

}

const getTrafficPaymentsByAffiliate = async (data) => {
 const {affiliateId,campaignId } = data
  try {
    const res = await api.post(
      '', {
        query: `
            {
              getTrafficPaymentsByAffiliate(
                affiliateId:${affiliateId},
                campaignId:${campaignId}
              ){
                percentage
                subCampaign
              }
            }
        `,
      }
    )

    let response = res.data.data.getTrafficPaymentsByAffiliate
    return response
  } catch (e) {
    console.log(e)
  }
}

export default {
  blocking,
  addBlocking,
  delBlocking,
  getActiveAffiliates,
  getTrafficPaymentsByAffiliate
}